import * as Immutable from 'immutable';
import * as React from 'react';
import { useState } from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { Modal } from 'semantic-ui-react';

import { openWorkdayWithLoginCredentials } from '../../actions/AuthenticationActions';
import { StateType } from '../../reducers';
import { accountDataFieldsCountrySelector } from '../../reducers/AccountReducer/AccountSelector';
import {
  getUserOnboardingSelector,
  getUserOnboardingStatusSelector,
  getUserPermissionSet,
} from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { getAuthCreds } from '../../shared/helpers/authStorage';
import { DispatchConnect, OnboardingStatus, Permission } from '../../types';

import { OnboardingPopupContent } from './OnboardingPopupContent';

interface OnboardingPopupProps {
  country: string;
  permissions: Set<Permission>;
  userOnboardingStatus: OnboardingStatus;
  userOnboarding: Immutable.Map<string, string> | null;
}

interface OnboardingDispatchers {
  dispatchOpenWorkday: () => void;
}

function getIsPopUpShown(status: string, country: string, permissions: Set<Permission>) {
  return (
    permissions.has('WORKDAY') &&
    ((status === 'QUESTIONNAIRE_APPROVED' && country !== 'RU') || status === 'INVITE_APPROVED' || status === 'BACKGROUND_CHECK_APPROVED')
  );
}

export function OnboardingModal({
  userOnboardingStatus,
  userOnboarding,
  country,
  permissions,
  dispatchOpenWorkday,
  history,
}: OnboardingPopupProps & OnboardingDispatchers & RouteComponentProps<any> & InjectedIntlProps) {
  const [isClosed, setIsClosed] = useState(false);

  if (userOnboardingStatus == null || isClosed || !getIsPopUpShown(userOnboardingStatus, country, permissions)) {
    return <></>;
  }

  const handleClose = () => {
    setIsClosed(true);
  };

  const handleOpenWorkday = () => {
    handleClose();
    if (!getAuthCreds()) {
      history.push('/profile/account/workday');

      return;
    }

    dispatchOpenWorkday();
  };

  return (
    <Modal open={!isClosed} size="tiny" closeIcon={true} onClose={handleClose}>
      <OnboardingPopupContent
        status={userOnboardingStatus}
        country={country}
        permissions={permissions}
        onClose={handleClose}
        onOpenWorkday={handleOpenWorkday}
      />
    </Modal>
  );
}

const mapStateToProps = (state: StateType): OnboardingPopupProps => ({
  // @ts-ignore
  country: accountDataFieldsCountrySelector(state),
  permissions: getUserPermissionSet(state),
  userOnboardingStatus: getUserOnboardingStatusSelector(state),
  // @ts-ignore
  userOnboarding: getUserOnboardingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): OnboardingDispatchers => ({
  dispatchOpenWorkday: async () => dispatch(openWorkdayWithLoginCredentials()),
});

export const OnboardingPopupContainer = withRouter(
  connect<OnboardingPopupProps, DispatchConnect<OnboardingDispatchers>, any, StateType>(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(OnboardingModal))
);
